import React from "react";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";

const useStyles = createUseStyles({
        "@keyframes slideAndBounce": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -100px)"
            },
            "40%": {
                opacity: 1,
                transform: "translate(-50%, 10px)"
            },
            "70%": {
                opacity: 1,
                transform: "translate(-50%, -10px)"
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, 0px)"
            }
        },
        hostBanner: {
            width: "100%",
        },
        hostName: {
            position: "relative",
            zIndex: 1,
            bottom: ({size}) => size / 9,
        },
        container: {
            animation: "$slideAndBounce 2s 1s forwards",
            opacity: 0,
            width: ({size}) => size,
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, 0%)",
            zIndex: 10,
            top: 0
        },
        // Moving top of svg off screen for short screens so it doesn't overlap the video
        "@media (max-height: 700px)": {
            container: {
                top: -40
            }
        },
        "@media (max-height: 600px)": {
            container: {
                top: -70
            }
        }
    }
);

export type HostNameProps = {
    name: string
    size: number
}

export const HostName = (props: HostNameProps) => {
    const {name, size} = props;
    const classes = useStyles({size});

    return <div className={classes.container}>
        <img src="/assets/host/common/host-name-banner.svg" className={classes.hostBanner}/>
        <DisplayText
            className={classes.hostName} 
            variant={TextVariant.s24reg} 
            color={"#AFDAE0"}> 
            {name.toUpperCase()}
        </DisplayText>
    </div>;
    };

export default HostName;
